<!-- (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026 -->
<template>
    <v-dialog :value="value" max-width="500px" @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="text-h5">{{ $t('general.are-you-sure-you-want-items') }}</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                >{{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="confirm"
                >{{ $t('general.ok') }}
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

// Confirmation before the selected orders are deleted; open state via v-model
export default {
    name: "DeleteSelectedDialog",
    props: {
        value: {type: Boolean, default: false},
        selected: {type: Array, default: () => []},
    },
    methods: {
        ...mapActions(["destroyOrder"]),
        close() {
            this.$emit('input', false);
        },
        async confirm() {
            this.selected.map((item) => {
                this.destroyOrder(item);
            });
            await this.$emit('done');
            this.close();
        },
    },
}
</script>
